import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import _ from "lodash";

@Component
export default class ListMixin extends AbpBase {
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  viewModalShow: boolean = false;
  namespace: string = "";
  pagerequest: any = {};

  get store() {
    return null;
  }
  get loading() {
    return this.store.loading;
  }
  get pageSize() {
    return this.store.pageSize;
  }
  get totalCount() {
    return this.store.totalCount;
  }
  get currentPage() {
    return this.store.currentPage;
  }
  get list() {
    return this.store.list;
  }
  refreshListData() {
    this.$store.commit(`${this.namespace}/refreshListData`);
  }
  refreshPageIndex() {
    this.$store.commit(`${this.namespace}/setCurrentPage`, 1);
  }
  pageChange(page: number) {
    this.$store.commit(`${this.namespace}/setCurrentPage`, page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setPageSize`, pagesize);
    this.getpage();
  }
  async searchData() {
    this.refreshPageIndex();
    await this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.preGetPage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAll`,
        data: this.pagerequest,
      })
      .catch(() => {
        this.store.loading = false;
      });
  }

  // for inherit can use to init data
  preGetPage() {}

  create() {
    this.createModalShow = true;
  }
  view(index) {
    this.$store.commit(`${this.namespace}/view`, this.list[index]);
    this.viewModalShow = true;
  }
  edit(index) {
    this.$store.commit(`${this.namespace}/edit`, this.list[index]);
    this.editModalShow = true;
  }
  remove(index) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L(`Delete${_.startCase(this.namespace)}Confirm`),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await this.$store.dispatch({
          type: `${this.namespace}/delete`,
          data: this.list[index],
        });
        this.afterRemove();
      },
    });
  }
  afterRemove() {
    this.getpage();
  }
  afterCreated() {}
  created() {
    this.afterCreated();
  }
}
